import { render, staticRenderFns } from "./voz-select.vue?vue&type=template&id=4213c4d4&scoped=true&"
import script from "./voz-select.vue?vue&type=script&lang=js&"
export * from "./voz-select.vue?vue&type=script&lang=js&"
import style0 from "./voz-select.vue?vue&type=style&index=0&id=4213c4d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4213c4d4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VMenu,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4213c4d4')) {
      api.createRecord('4213c4d4', component.options)
    } else {
      api.reload('4213c4d4', component.options)
    }
    module.hot.accept("./voz-select.vue?vue&type=template&id=4213c4d4&scoped=true&", function () {
      api.rerender('4213c4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/voz-select/voz-select.vue"
export default component.exports